import { StyleStateEnum } from '../../../../Common/PageBuilder/enums/style-state.enum';
import { DistributionStyleStateEnum } from '../../../../Common/TargetingShared/enum/distribution-style-state.enum';
import { DistributionBlockTypeEnum } from '../../enums/distribution-block-type.enum';
import { TextStyleModel } from '../../../../Common/PageBuilder/models/text-style.model';
import { ImageStyleModel } from '../../../../Common/PageBuilder/models/image-style.model';
import { DividerStyleModel } from '../../../../Common/PageBuilder/models/divider-style.model';
import { ButtonStyleModel } from '../../../../Common/PageBuilder/models/button-style.model';
import { DefaultFontsEnum } from '../../../../Common/PageBuilder/enums/default-fonts.enum';
import { SocialLinkStyleModel } from '../../../../Common/PageBuilder/models/link-style.model';
import { LinkLayoutOptionEnum } from '../../../../Common/PageBuilder/enums/link-layout-option.enum';
import { LinkDisplayOptionEnum } from '../../../../Common/PageBuilder/enums/link-display-option.enum';
import { LayoutStyle } from '../../../../Common/PageBuilder/models/layout-style.model';
import { VerticalAlignmentEnum } from '../../../../Common/Forms/enums/vertical-alignment.enum';
import { LayoutBlockDisplayRatiosEnum } from '../../../../Common/PageBuilder/enums/layout-block-display-ratios.enum';

export const defaultDistributionStyleOne = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#292929',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.title]: new TextStyleModel({
        color: '#005494',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'left',
        imageAlignment: 'center',
        bold: false,
        color: '#5e6473',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.button]: new ButtonStyleModel({
        bold: true,
        buttonAlignment: 'center',
        buttonColor: '#007BD8',
        buttonBackgroundColor: 'FFFFFF',
        buttonShape: 0,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        fontColor: '#FFFFFF',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.footer]: new TextStyleModel({
        alignment: 'center',
        backgroundColor: '#e5e5e5',
        bold: false,
        color: '#000000',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '12px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.link]: new SocialLinkStyleModel({
        iconColor: 'light',
        backgroundColor: '#FFFFFF',
        iconSize: 'medium',
        iconShape: 4,
        displayOption: LinkDisplayOptionEnum.iconOnly,
        layoutOption: LinkLayoutOptionEnum.horizontal,
        iconBackgroundColor: '#101010',
        color: '#000000',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: true,
        alignment: 'center',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.oneColumnLayout]: new LayoutStyle({
        backgroundColor: '#ffffff',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.twoColumnLayout]: new LayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE,
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.threeColumnLayout]: new LayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE,
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    })
};

export const defaultDistributionStyleTwo = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#292929',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_2
    })
};

export const defaultDistributionStyleThree = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#292929',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.title]: new TextStyleModel({
        color: '#000000',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '24px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'left',
        imageAlignment: 'center',
        bold: false,
        color: '#5e6473',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.button]: new ButtonStyleModel({
        bold: true,
        buttonAlignment: 'center',
        buttonColor: '#007BD8',
        buttonBackgroundColor: 'FFFFFF',
        buttonShape: 0,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        fontColor: '#FFFFFF',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.footer]: new TextStyleModel({
        alignment: 'center',
        backgroundColor: '#f7f7f7',
        bold: false,
        color: '#000000',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '12px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
};

export const defaultDistributionStyleFour = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#292929',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.title]: new TextStyleModel({
        color: '#005494',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'right',
        imageAlignment: 'center',
        bold: false,
        color: '#292929',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#ff5126',
        height: 1,
        marginBottom: 20,
        marginTop: 0,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.button]: new ButtonStyleModel({
        bold: true,
        buttonAlignment: 'center',
        buttonColor: '#ff5126',
        buttonBackgroundColor: 'FFFFFF',
        buttonShape: 4,
        fontColor: '#FFFFFF',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.footer]: new TextStyleModel({
        alignment: 'center',
        backgroundColor: '#F4ECE9',
        bold: false,
        color: '#000000',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '12px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
};

export const defaultDistributionStyleFive = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#F4ECE9',
        bold: false,
        color: '#292929',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '16px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_5,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_5
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#ff5126',
        height: 1,
        marginBottom: 0,
        marginTop: 20,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_5,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_5
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'right',
        imageAlignment: 'center',
        bold: false,
        color: '#5e6473',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_5,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_5
    }),
};


export const newBrandingDefaultDistributionStyleOne = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#1e1e1e',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.title]: new TextStyleModel({
        color: '#231F44',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'right',
        imageAlignment: 'center',
        bold: false,
        color: '#5e6473',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.button]: new ButtonStyleModel({
        bold: true,
        buttonAlignment: 'center',
        buttonColor: '#00E6B5',
        buttonBackgroundColor: 'FFFFFF',
        buttonShape: 0,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        fontColor: '#231F44',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.footer]: new TextStyleModel({
        alignment: 'center',
        backgroundColor: '#e5e5e5',
        bold: false,
        color: '#1e1e1e',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '12px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.link]: new SocialLinkStyleModel({
        iconColor: 'light',
        backgroundColor: '#FFFFFF',
        iconSize: 'medium',
        iconShape: 4,
        displayOption: LinkDisplayOptionEnum.iconOnly,
        layoutOption: LinkLayoutOptionEnum.horizontal,
        iconBackgroundColor: '#101010',
        color: '#000000',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: true,
        alignment: 'center',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.oneColumnLayout]: new LayoutStyle({
        backgroundColor: '#ffffff',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.twoColumnLayout]: new LayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE,
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    }),
    [DistributionBlockTypeEnum.threeColumnLayout]: new LayoutStyle({
        displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE,
        backgroundColor: '#ffffff',
        verticalAlignment: VerticalAlignmentEnum.TOP,
        columnSpacing: 10,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_1,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_1
    })
};

export const newBrandingDefaultDistributionStyleTwo = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#1e1e1e',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_2
    })
};

export const newBrandingDefaultDistributionStyleThree = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#1e1e1e',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.title]: new TextStyleModel({
        color: '#000000',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '24px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'left',
        imageAlignment: 'center',
        bold: false,
        color: '#5e6473',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#C7C7C7',
        height: 2,
        marginBottom: 20,
        marginTop: 20,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.button]: new ButtonStyleModel({
        bold: true,
        buttonAlignment: 'center',
        buttonColor: '#007BD8',
        buttonBackgroundColor: 'FFFFFF',
        buttonShape: 0,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        fontColor: '#FFFFFF',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
    [DistributionBlockTypeEnum.footer]: new TextStyleModel({
        alignment: 'center',
        backgroundColor: '#f7f7f7',
        bold: false,
        color: '#000000',
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_3,
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '12px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_3
    }),
};

export const newBrandingDefaultDistributionStyleFour = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#FFFFFF',
        bold: false,
        color: '#1e1e1e',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.title]: new TextStyleModel({
        color: '#231F44',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        bold: false,
        italics: false,
        underlined: false,
        alignment: 'center',
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'right',
        imageAlignment: 'center',
        bold: false,
        color: '#1e1e1e',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#00E6B5',
        height: 1,
        marginBottom: 20,
        marginTop: 0,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.button]: new ButtonStyleModel({
        bold: true,
        buttonAlignment: 'center',
        buttonColor: '#00E6B5',
        buttonBackgroundColor: 'FFFFFF',
        buttonShape: 4,
        fontColor: '#231F44',
        fontFamily: DefaultFontsEnum.Arial,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
    [DistributionBlockTypeEnum.footer]: new TextStyleModel({
        alignment: 'center',
        backgroundColor: '#E0F8ED',
        bold: false,
        color: '#000000',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '12px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_4,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_4
    }),
};

export const newBrandingDefaultDistributionStyleFive = {
    [DistributionBlockTypeEnum.text]: new TextStyleModel({
        alignment: 'left',
        backgroundColor: '#E0F8ED',
        bold: false,
        color: '#1e1e1e',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '16px',
        htmlEdit: false,
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_5,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_5
    }),
    [DistributionBlockTypeEnum.divider]: new DividerStyleModel({
        dividerColor: '#00E6B5',
        height: 1,
        marginBottom: 0,
        marginTop: 20,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_5,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_5
    }),
    [DistributionBlockTypeEnum.image]: new ImageStyleModel({
        alignment: 'right',
        imageAlignment: 'center',
        bold: false,
        color: '#5e6473',
        fontFamily: DefaultFontsEnum.Times,
        fontSize: '14px',
        italics: false,
        underlined: false,
        styleState: DistributionStyleStateEnum.DISTRIBUTION_5,
        displayStyleState: DistributionStyleStateEnum.DISTRIBUTION_5
    }),
};

export const defaultDistributionStyles = {
    [StyleStateEnum.DEFAULT]: defaultDistributionStyleOne,
    [DistributionStyleStateEnum.DISTRIBUTION_1]: defaultDistributionStyleOne,
    [DistributionStyleStateEnum.DISTRIBUTION_2]: defaultDistributionStyleTwo,
    [DistributionStyleStateEnum.DISTRIBUTION_3]: defaultDistributionStyleThree,
    [DistributionStyleStateEnum.DISTRIBUTION_4]: defaultDistributionStyleFour,
    [DistributionStyleStateEnum.DISTRIBUTION_5]: defaultDistributionStyleFive
};


export const newBrandingDefaultDistributionStyles = {
    [StyleStateEnum.DEFAULT]: defaultDistributionStyleOne,
    [DistributionStyleStateEnum.DISTRIBUTION_1]: newBrandingDefaultDistributionStyleOne,
    [DistributionStyleStateEnum.DISTRIBUTION_2]: newBrandingDefaultDistributionStyleTwo,
    [DistributionStyleStateEnum.DISTRIBUTION_3]: newBrandingDefaultDistributionStyleThree,
    [DistributionStyleStateEnum.DISTRIBUTION_4]: newBrandingDefaultDistributionStyleFour,
    [DistributionStyleStateEnum.DISTRIBUTION_5]: newBrandingDefaultDistributionStyleFive
};


